import { render, staticRenderFns } from "./lawdetzz.vue?vue&type=template&id=f608176a&scoped=true&"
import script from "./lawdetzz.vue?vue&type=script&lang=js&"
export * from "./lawdetzz.vue?vue&type=script&lang=js&"
import style0 from "./lawdetzz.vue?vue&type=style&index=0&id=f608176a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f608176a",
  null
  
)

export default component.exports